import { Link } from "react-scroll";
import { useEffect } from "react";

function Navbar() {
  const handleScroll = () => {
    const gotop = document.querySelector(".gotop");
    const nav = document.querySelector(".navbar");

    if (window.screen.width < 768 && window.scrollY > 690) {
      gotop.classList.add("display");
      nav.classList.add("navopened");
    } else if (window.screen.width > 768 && window.scrollY > 220) {
      gotop.classList.add("display");
      nav.classList.add("navopened");
    } else {
      gotop.classList.remove("display");
      nav.classList.remove("navopened");
    }
  };

  useEffect(() => {
    document.addEventListener("scroll", handleScroll);
    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const openBar = () => {
    const bar = document.querySelector(".bar");
    bar.classList.toggle("opened");
  };

  // Adjust this value based on the height of your fixed navbar
  const offsetValue = -100; // Example value, adjust as needed

  return (
    <nav className="navbar">
      <div className="container">
        <div className="row">
          <h1 className="logo">
            <Link spy={true} smooth={true} duration={1000} to="headerbg" style={{ cursor: "pointer" }}>
              MP-Tech Piotr Mętel
            </Link>
          </h1>
          <ul className="bar">
            <li>
              <Link
                onClick={openBar}
                activeClass="active"
                spy={true}
                smooth={true}
                duration={1000}
                to="headerbg"
                offset={offsetValue}
              >
                Główna
              </Link>
            </li>
            <li>
              <Link
                onClick={openBar}
                activeClass="active"
                to="services"
                spy={true}
                smooth={true}
                duration={1000}
                offset={offsetValue}
              >
                Usługi
              </Link>
            </li>
            <li>
              <Link
                onClick={openBar}
                to="main-title about-h2"
                spy={true}
                smooth={true}
                duration={1000}
                activeClass="active"
                offset={offsetValue}
              >
                O Nas
              </Link>
            </li>
            <li>
              <Link
                onClick={openBar}
                to="main-title financing-h2"
                spy={true}
                smooth={true}
                duration={1000}
                activeClass="active"
                offset={offsetValue}
              >
                Projekty UE
              </Link>
            </li>
            <li>
              <Link
                onClick={openBar}
                to="main-title gallery-h2"
                spy={true}
                smooth={true}
                duration={1000}
                activeClass="active"
                offset={offsetValue}
              >
                Galeria
              </Link>
            </li>
            {/*<li>*/}
            {/*  <Link*/}
            {/*    onClick={openBar}*/}
            {/*    to="contact"*/}
            {/*    spy={true}*/}
            {/*    smooth={true}*/}
            {/*    duration={1000}*/}
            {/*    activeClass="active"*/}
            {/*    offset={offsetValue}*/}
            {/*  >*/}
            {/*    Kontakt*/}
            {/*  </Link>*/}
            {/*</li>*/}
          </ul>
          <div className="button" onClick={openBar}>
            <div className="burger"></div>
            <div className="burger"></div>
            <div className="burger"></div>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
